import { createSelector } from '@reduxjs/toolkit';

import { selectComplaintsState } from './selectComplaintsState';

export const selectComplaintsModalOpened = createSelector(selectComplaintsState, state => state.modalOpened);
